export enum MeasurementUnits {
  Imperial = 'imperial',
  Metric = 'metric',
}
